import browserUpdate from 'browser-update';

export const MODULE_NAME = 'checkbrowser';
export let global_vars = {};

// Browser update configuration
//
// Anything older than the last 2 versions behind latest will cause notification
// to appear for the following browsers:
//
// * opera
//
// * chrome
//
// * safari
//
// * Firefox
//
// * edge
const CONFIG = {
    required: { e: -2, i: 12, f: -2, o: -2, s: -2, c: -2 },
    insecure: true,
    unsupported: true,
    api: 2018.07,
};

export function initialize(global) {
    CONFIG.l = global.document.body.dataset.lang;
    browserUpdate(CONFIG);
}
